import { createSlice } from "@reduxjs/toolkit";

export const listManufaturerSlice = createSlice({
  name: "listManufaturer",
  initialState: {
    listManufaturers: [],
    dropdownManufaturers: [],
    deleteID: [],
    selected: [],
  },
  reducers: {
    fillListManufacturerData: (state, payload) => {
      state[payload.payload.fieldName] = payload.payload.value;
    },
  },
});

export const { fillListManufacturerData } = listManufaturerSlice.actions;

export default listManufaturerSlice.reducer;
